import { graphql } from '@/gql'

export const FieldableFormCustomFieldsQuery = graphql(
  /* GraphQL */
  `
    query FieldableFormCustomFields(
      $viewerAccount: ID!
      $accounts: [ID!]
      $appliesTo: [TypeSupportingCustomFieldValues!]
      $first: Int
    ) {
      customFields(accounts: $accounts, appliesTo: $appliesTo, first: $first) {
        data {
          ...FieldableFormCustomField
        }
      }
    }
  `,
)

export const FieldableFormInheritedCustomFieldsQuery = graphql(
  /* GraphQL */
  `
    query FieldableFormInheritedCustomFields(
      $viewerAccount: ID!
      $accounts: [ID!]
      $appliesTo: [TypeSupportingCustomFieldValues!]
      $first: Int
    ) {
      inheritedCustomFields(accounts: $accounts, appliesTo: $appliesTo, first: $first) {
        data {
          ...FieldableFormCustomField
        }
      }
    }
  `,
)

export const SupplierSharedCustomFieldsQuery = graphql(
  /* GraphQL */
  `
    query SupplierSharedCustomFields(
      $viewerAccount: ID!
      $supplier: ID!
      $appliesTo: [TypeSupportingCustomFieldValues!]
      $first: Int
    ) {
      supplierSharedCustomFields(supplier: $supplier, appliesTo: $appliesTo, first: $first) {
        data {
          ...FieldableFormCustomField
        }
      }
    }
  `,
)
